var ExtentConfiguration = /** @class */ (function () {
    function ExtentConfiguration(obj) {
        this.label = 'Go To Extent';
        this.toolTip = 'Click to go to Extent';
        /** Calcite Icon Name or SVG Path */
        this.icon = '';
        this.color = 'default';
        this.extentType = 'static';
        Object.assign(this, obj);
        if (!this.extentType || (this.extentType !== 'static' && typeof this.extent !== 'function')) {
            throw new Error('extentType is invalid');
        }
    }
    Object.defineProperty(ExtentConfiguration.prototype, "isSVG", {
        get: function () { return this.icon.toLowerCase().startsWith('m') && this.icon.endsWith('z'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtentConfiguration.prototype, "qualifiedIcon", {
        get: function () { return this.isSVG ? null : this.icon.startsWith('icon-ui-') ? this.icon : "icon-ui-" + this.icon; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtentConfiguration.prototype, "qualifiedIconColor", {
        get: function () { return this.color === 'default' ? null : "icon-ui-" + this.color; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtentConfiguration.prototype, "qualifiedSVGColor", {
        get: function () { return this.color === 'default' ? null : "svg-icon-" + this.color; },
        enumerable: true,
        configurable: true
    });
    return ExtentConfiguration;
}());
export default ExtentConfiguration;
export var ExtentConfigurationConverter = function (value) {
    if (typeof value === 'string') {
        return new ExtentConfiguration(JSON.parse(value));
    }
    if (typeof value === 'object') {
        return new ExtentConfiguration(value);
    }
    return value;
};
export var ExtentConfigurationArrayConverter = function (value) {
    if (typeof value === 'string') {
        return JSON.parse(value).map(function (c) { return new ExtentConfiguration(c); });
    }
    if (typeof value === 'object') {
        return value.map(function (c) { return new ExtentConfiguration(c); });
    }
    return value;
};
